import React, { useEffect } from "react";
import { Cards } from './Cards';
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { ItemFile } from "../../../../store/viewmodels/ItemFileViewModel";
import { shuffle } from "../../../../utils/ItemServices";

export interface GameBoardProps {
    amountOfPairs: number,
    item: Item
    score: number
    setScore: React.Dispatch<React.SetStateAction<number>>,
    pairs: number,
    setPairs: React.Dispatch<React.SetStateAction<number>>,
    turn: boolean,
    setTurn: React.Dispatch<React.SetStateAction<boolean>>,
    setFeedBackType: React.Dispatch<React.SetStateAction<string>>,
}

export function GameBoard(props: GameBoardProps): JSX.Element {
    const [game, setGame] = React.useState([] as any[]);
    const [flippedCount, setFlippedCount] = React.useState(0);
    const [flippedIndexes, setFlippedIndexes] = React.useState([] as { index: number, side: string }[]);
    const [matchedIndexes, setMatchedIndexes] = React.useState([] as number[]);
    const [feedBack, setFeedBack] = React.useState(<></>);
    const [check, setCheck] = React.useState(-1);
    const [hideMatched, setHideMatched] = React.useState(true);

    const itemFiles: ItemFile[] = props.item.files;

    let maxCount = props.amountOfPairs <= props.item.child_items.length ? props.amountOfPairs : props.item.child_items.length;

    useEffect(() => {
        const videoCards = [];
        const imageCards = [];
        let backgroundFile: ItemFile | undefined = itemFiles.find(file => file.file.includes("jpg") || file.file.includes("png") || file.file.includes("jpeg"));

        for (let i: number = 0; i < maxCount; i++) {
            const firstCard = {
                item: props.item.child_items[i],
                file: props.item.child_items[i].files[0],
                background: backgroundFile
            }

            const secondCard = {
                item: props.item.child_items[i],
                file: props.item.child_items[i].files[1],
                background: backgroundFile
            }

            imageCards.push(firstCard);
            videoCards.push(secondCard);
        }

        const shuffledImageCards = shuffle(imageCards);
        const shuffledVideoCards = shuffle(videoCards);
        const allCards = shuffledImageCards.concat(shuffledVideoCards); //all cards

        setGame(allCards);
        setFlippedCount(0);
        setFlippedIndexes([]);
        setMatchedIndexes([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.amountOfPairs]);

    useEffect(() => {
        props.setPairs(matchedIndexes.length / 2);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchedIndexes]);

    if (flippedIndexes.length === 2) {
        let firstCard = flippedIndexes[0];
        let secondCard = flippedIndexes[1];
        const match = game[firstCard.index].item.id === game[secondCard.index].item.id;

        if (match) {
            const newMatched = [...matchedIndexes];
            newMatched.push(flippedIndexes[0].index);
            newMatched.push(flippedIndexes[1].index);

            setMatchedIndexes(newMatched);
            let newIndexes: any[] = [];
            setFlippedIndexes(newIndexes);         
            
            let message = (
                <div className="flex my-auto mx-auto justify-center font-medium text-green-500">
                    <span className="">Hienoa! Löysit parin!</span>
                    <span className="ml-2 ri-game-fill"></span>
                </div>
            );

            
            setTimeout(() => {
                setFeedBack(message);
                props.setFeedBackType("correct");
                setHideMatched(!hideMatched);
                setTimeout(() => {
                    setFeedBack(prev => <></>);
                    props.setFeedBackType("");
                }, 1500);
            }, 1500);

        } else {
            if (check < 0) {
                setCheck(1);
                let message = (
                    <div className="flex my-auto mx-auto justify-center text-red-500">
                        <span>Yritä uudelleen!</span>
                    </div>
                );


                setTimeout(() => {
                    setFeedBack(message);
                    props.setFeedBackType("wrong");

                    setHideMatched(!hideMatched)
                    setTimeout(() => {
                        setFeedBack(prev => <></>);
                        props.setFeedBackType("");
                        props.setTurn(true)
                    }, 1500);
                }, 1500)
            }
        }
    }

    useEffect(() => {
        if (flippedIndexes.length === 0) {
            props.setTurn(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flippedIndexes])

    useEffect(() => {
        if (props.turn) {
            setCheck(-1);
            let newIndexes: any[] = [];
            setFlippedIndexes(newIndexes);
        }
    }, [props.turn])

    if (game.length === 0) return (<div className="m-auto text-center text-teal-500 text-lg md:text-xl lg:text-2xl 2xl:text-3xl 4xl:text-4xl 7xl:text-5xl 10xl:text-6xl">Peli latautuu...</div>);
    else {
        let gameBoard = (
            <div className="">
                <div className="my-auto h-6 md:h-8 lg:h-10 2xl:h-12 4xl:h-14 7xl:h-20 10xl:h-24 m-auto text-center text-teal-500 text-lg md:text-xl lg:text-2xl 2xl:text-3xl 4xl:text-4xl 7xl:text-5xl 10xl:text-6xl">
                    {feedBack}
                </div>
                <div className="flex flex-wrap justify-center ">
                    <Cards
                        game={game}
                        flippedCount={flippedCount}
                        flippedIndexes={flippedIndexes}
                        setFlippedCount={setFlippedCount}
                        setFlippedIndexes={setFlippedIndexes}
                        setScore={props.setScore}
                        score={props.score}
                        matchedIndexes={matchedIndexes}
                        level={props.amountOfPairs}
                        feedBack={feedBack}
                        setFeedBack={setFeedBack}
                        turn={props.turn}
                        hideMatched={hideMatched}
                    />
                </div>
            </div>
        )
        return gameBoard;
    }
}